import { Box } from "@mui/material";
import { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../../components/Header";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import SalesForm from "../../../components/SalesForm";
import { useTranslation } from "react-i18next";

const UpdateInvoices = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sale, setSale] = useState(null);
  const [open, setOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const apiUrl = "https://oven-backend.onrender.com";

  useEffect(() => {
    const fetchSale = async () => {
      try {
        const response = await axios.get(`${apiUrl}/sales/${id}`);

        if (!response.data.products || response.data.products.length === 0) {
          console.warn("⚠️ لا توجد منتجات في البيانات المسترجعة");
        }

        setSale(response.data);
      } catch (error) {
        console.error("❌ خطأ أثناء جلب بيانات المبيعات:", error);
      }
    };

    fetchSale();
  }, [id]);

  const handleFormSubmit = async (values) => {
    try {
      const updatedProducts = values.products.map((product) => ({
        name_sales: product.name_sales,
        quantity: Number(product.quantity),
        price: Number(product.price),
      }));

      const totalAmount = updatedProducts.reduce(
        (acc, product) => acc + product.price * product.quantity,
        0
      );

      const formattedValues = {
        ...values,
        products: updatedProducts,
        total_amount: totalAmount,
      };

      const response = await axios.patch(`${apiUrl}/sales/${id}`, formattedValues);
      console.log("✅ Sales updated successfully:", response.data);
      setOpen(true);
      setTimeout(() => {
        navigate("/invoices");
      }, 1000);
    } catch (error) {
      console.error("❌ Error updating sales:", error.response?.data || error);
      alert(`Error: ${JSON.stringify(error.response?.data, null, 2)}`);
    }
  };

  if (!sale) {
    return <Box m="20px">{t("loading")}</Box>;
  }

  const initialValues = {
    employee_id: sale.employee_id?._id || "",
    products:
      sale.products && sale.products.length > 0
        ? sale.products.map((p) => ({
            name_sales: p.name_sales || "",
            quantity: p.quantity?.toString() || "",
            price: p.price?.toString() || "",
          }))
        : [{ name_sales: "", quantity: "", price: "" }],
    payment_status: sale.payment_status || "pending",
    inventory_status: sale.inventory_status || "pending",
    date: sale.date ? sale.date.split("T")[0] : "",
  };


  return (
    <Box m="20px" sx={{ direction: isRTL ? "rtl" : "ltr" }}>
      <Header title={t("update_sales")} subtitle={t("update_sales_subtitle")} />
      <SalesForm
        initialValues={initialValues}
        handleFormSubmit={handleFormSubmit}
        buttonLabel={t("update_sale_button")}
      />
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {t("success_update")}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UpdateInvoices;